import { render, staticRenderFns } from "./CreateNewAdvisoryStatusModal.vue?vue&type=template&id=c1dbe930"
import script from "./CreateNewAdvisoryStatusModal.vue?vue&type=script&lang=js"
export * from "./CreateNewAdvisoryStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports